

export { Table } from "./table";

export const DEFAULT_COLUMN_WIDTH = 150;
